import React, {useContext, useEffect, useState} from "react";
import {PerfilContext} from "../../contexts/Perfil/PerfilContext";
import {Input} from "../../components/Input";
import {Select} from "../../components/Select";
import {SlidingBox} from "../../components/SlidingBox";
import {MailBox} from "./mailBox";
import {PhoneBox} from "./phoneBox";
import {PassBox} from "./passBox";
import {DoisFatoresBox} from "./doisFatoresBox";
import {PlanBox} from "./planBox";
import {Button} from "../../components/Button";
import {PerfilApi} from "../../hooks/perfilApi";
import {DoisFatoresApi, DoisFatoresStatus} from "../../hooks/doisFatoresApi";
import ModalSucesso from "../../components/Modal/ModalSucesso";
import Modal from "../../components/Modal/Modal";
import Titulo from "../../components/Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo";
import {Middle, LeftRight, ViewPerfil, ViewModalPermissoes, ViewModalDetalhesAssinatura} from "./styles";
import {useTheme} from "../../contexts/Theme/ThemeContext";
import SkeletonPerfil from "../../components/Skeletons/SkeletonPerfil/SkeletonPerfil";
import {validateEmail, validatePhone} from "../../services/MasksValidations";
import Swal from "sweetalert2";
import Form from "../../components/Form";
import {phoneMask} from "../../services/Masks";
import {unmaskToNumbers} from "../../services/Unmasks";
import {Link} from "react-router-dom";
import LockedIcon from "../../components/LockedIcon/LockedIcon";
import {EmpresaContext} from "../../contexts/Empresa/EmpresaContext";
import {AssinaturaContext} from "../../contexts/Assinatura/AssinaturaContext";
import src from "../../assets/jsons/Loading.json";
import {Controls, Player} from "@lottiefiles/react-lottie-player";
import moment from "moment";
import { legadoParaFino, PERMISSOES } from "../../services/Consts";
import { PainelPermissoes } from "./PainelPermissoes/PainelPermissoes";
import { AuthContext } from "../../contexts/Auth/AuthContext";

export const Perfil = () => {
    const {empresa} = useContext(EmpresaContext);
    const {fluxoNovo} = useContext(AssinaturaContext);
    const {permissoesUsuario} = useContext(AuthContext);
    const Usuarios = React.useContext(PerfilContext);
    const [MeusUsuarios, setMeusUsuarios] = useState<Array<any>>([]);
    const [nomeJaExiste, setNomeJaExiste] = useState(true);
    const [loadingNomeUsuario, setLoadingNomeUsuario] = useState(false);
    const [usuariosNomes, setUsuariosNomes] = useState([
        {
            name: "Gerente",
            value: 1,
        },
    ]); // Nomes dos usuários
    const [usuario, setUsuario] = useState<any>({});
    const [presets, setPresets] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(true);
    const [periodicidade, setPeriodicidade] = useState({
        periodicidade: "",
        nome_plano: "",
        data_inicio: "",
        data_expiracao: "",
    });

    const [modalAtualizando, setModalAtualizando] = useState(false);
    const [mensagemModal, setMensagemModal] = useState(
        "Salvando dados, aguarde...",
    );
    const [stateModal, setStateModal] = useState("loading");
    const [needInit, setNeedInit] = useState(false);
    const [salvarHabilitado, setSalvarHabilitado] = useState(false);

    const [limiteLicencaAtingido, setLimiteLicencaAtingido] = useState(true);
    const [avisoLimiteAtingido, setAvisoLimiteAtingido] = useState(false);

    const [mailBox, setMailBox] = useState(false);
    const [phoneBox, setPhoneBox] = useState(false);
    const [passBox, setPassBox] = useState(false);
    const [doisFatoresBox, setDoisFatoresBox] = useState(false);
    const [doisFatores, setDoisFatores] = useState<DoisFatoresStatus | null>(null);
    const [planBox, setPlanBox] = useState(false);

    const [modalPermissao, setmodalPermissao] = useState(false);

    const [modalDetalhesAssinatura, setModalDetalhesAssinatura] = useState(false);
    const [detalhesAssinatura, setDetalhesAssinatura] = useState<any>(null);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const {theme} = useTheme();

    // Presets = os cargos (permissoes_cargos), traduzidos para o modelo fino v2 do painel.
    const getPresetPermissoes = (idCargo: any): number[] => {
        const preset = presets.find((p) => String(p.id_cargo) === String(idCargo));
        return preset ? legadoParaFino(preset.permissoes) : [];
    };

    // "Personalizado" = o conjunto atual difere das permissões do preset (cargo) selecionado.
    const isPersonalizado = (u: any = usuario): boolean => {
        const base = getPresetPermissoes(u?.tipo)
            .slice()
            .sort((a, b) => a - b)
            .join(",");
        const atual = (Array.isArray(u?.permissoes) ? u.permissoes : [])
            .slice()
            .sort((a: number, b: number) => a - b)
            .join(",");
        return base !== atual;
    };

    const handleNovoUsuario = () => {
        setMailBox(false);
        setPassBox(false);
        setPhoneBox(false);
        setDoisFatoresBox(false);
        setUsuario({
            nome: "",
            email: "",
            email_notificacao: "",
            senha: "",
            telefone: "",
            tipo: "1",
            permissoes: getPresetPermissoes("1"),
            novo: true,
        });
    };

    const handleEmailChange = (newEmail: string) => {
        setUsuario({
            ...usuario,
            email_notificacao: newEmail,
        });
    };

    const handleSalvar = async (usuario: any) => {
        // Sinaliza ao backend se é personalizado: grava usuario_permissoes (fino) ou
        // reseta para o cargo. Só quando há conjunto carregado (evita mexer no gerente principal).
        const payload = {
            ...usuario,
            permissoes_customizadas: Array.isArray(usuario?.permissoes) && isPersonalizado(usuario),
        };
        PerfilApi()
            .salvarUsuario(payload)
            .then((response) => {
                Swal.fire({
                    icon: "success",
                    title: "Dados salvos com sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                });
                setModalAtualizando(false);
                setMensagemModal("Dados salvos com sucesso!");
                setStateModal("success");
                setNeedInit(true);
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Erro ao salvar os dados",
                    showConfirmButton: false,
                    timer: 1500,
                });
                setModalAtualizando(false);
                setMensagemModal("Erro ao salvar os dados");
                setStateModal("error");
            });
    };

    async function removerUsuario() {
        // Show loading while fetching catalogs
        Swal.fire({
            title: "Carregando...",
            text: "Buscando catálogos do usuário",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const catalogos = await PerfilApi().getCatalogosUsuario(usuario.nome);

            // Build the HTML for catalog list
            let htmlContent = "";
            if (catalogos && catalogos.length > 0) {
                const catalogosList = catalogos
                    .map((cat: any) => `- ${cat.descricao || cat.nome || "Catálogo sem nome"} <br/>`)
                    .join("");
                htmlContent = `
                    <p>Os seguintes catálogos criados por ele também serão excluídos:</p>
                    ${catalogosList}
                `;
            } else {
                htmlContent = `<p>Este usuário não tem nenhum catálogo criado por ele</p>`;
            }

            // First modal - show warning with catalog list
            Swal.fire({
                title: "Tem certeza que deseja excluir este usuário?",
                html: htmlContent,
                icon: "warning",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Continuar",
                showCancelButton: true,
                customClass: {
                    confirmButton: "btn-confirm",
                    cancelButton: "btn-cancel",
                    icon: "custom-swal-icon",
                },
            }).then(async (result) => {
                if (result.isConfirmed) {
                    // Second modal - 5 second countdown
                    Swal.fire({
                        title: "Confirme sua ação",
                        text: "Após confirmar a exclusão, a ação não pode ser desfeita.",
                        icon: "warning",
                        confirmButtonText: "Confirmar (5)",
                        cancelButtonText: "Cancelar",
                        showCancelButton: true,
                        customClass: {
                            confirmButton: "btn-confirm2",
                            popup: "custom-swal-popup",
                            icon: "custom-swal-icon",
                            title: "custom-swal-title",
                        },
                        didOpen: () => {
                            const confirmButton = Swal.getConfirmButton();
                            if (confirmButton) {
                                confirmButton.disabled = true;
                                let secondsLeft = 5;
                                const timerInterval = setInterval(() => {
                                    secondsLeft--;
                                    confirmButton.innerText = `Confirmar (${secondsLeft})`;
                                    if (secondsLeft <= 0) {
                                        clearInterval(timerInterval);
                                        confirmButton.disabled = false;
                                        confirmButton.innerText = "Confirmar";
                                    }
                                }, 1000);
                            }
                        },
                    }).then(async (secondResult) => {
                        if (secondResult.isConfirmed) {
                            PerfilApi()
                                .removerUsuario(usuario.nome)
                                .then((response) => {
                                    setNeedInit(true);
                                    Swal.fire({
                                        icon: "success",
                                        title: "Usuário excluído com sucesso!",
                                        showConfirmButton: false,
                                        timer: 1500,
                                    }).then(() => {
                                        Swal.fire({
                                            title: "🔒 Dica de segurança",
                                            text: "Um usuário foi removido. Para garantir a segurança da conta, sugerimos que altere a senha dos demais usuários.",
                                            icon: "warning",
                                            confirmButtonText: "Estou ciente (5)",
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            customClass: {
                                                confirmButton: "btn-confirm2",
                                                popup: "custom-swal-popup",
                                                title: "custom-swal-title",
                                                icon: "custom-swal-icon",
                                            },
                                            didOpen: () => {
                                                const confirmButton = Swal.getConfirmButton();
                                                if (confirmButton) {
                                                    confirmButton.disabled = true;
                                                    let secondsLeft = 5;
                                                    const timerInterval = setInterval(() => {
                                                        secondsLeft--;
                                                        confirmButton.innerText = `Estou ciente (${secondsLeft})`;
                                                        if (secondsLeft <= 0) {
                                                            clearInterval(timerInterval);
                                                            confirmButton.disabled = false;
                                                            confirmButton.innerText = "Estou ciente";
                                                        }
                                                    }, 1000);
                                                }
                                            },
                                        }).then((result) => {
                                            PerfilApi().registrarLogExclusaoUsuario(
                                                usuario.nome,
                                                result.isConfirmed === true,
                                            );
                                        });
                                    });
                                })
                                .catch((error) => {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Erro ao excluir o usuário",
                                        showConfirmButton: false,
                                        timer: 1500,
                                    });
                                });
                        }
                    });
                }
            });
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Erro ao buscar catálogos",
                text: "Não foi possível buscar os catálogos do usuário",
                confirmButtonText: "Ok",
            });
        }
    }

    async function verificaNomeUsuario(usuario: string) {
        try {
            const response = await PerfilApi().verificaNomeUsuario(usuario);
            setNomeJaExiste(response); // Retorna true se o nome de usuário já estiver sendo usado, ou false se estiver disponível
        } catch (error) {
            return false; // Retorna false em caso de erro
        }
    }


    const handleInfoModal = () => {
        setmodalPermissao(true);
    };

    const handleVerDetalhesAssinatura = async () => {
        setModalDetalhesAssinatura(true);
        setLoadingDetalhes(true);
        try {
            const detalhes = await PerfilApi().getDetalhesAssinatura();
            setDetalhesAssinatura(detalhes);
        } catch (error) {
            console.error("Erro ao buscar detalhes da assinatura:", error);
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const carregarDoisFatores = async () => {
        try {
            setDoisFatores(await DoisFatoresApi().status());
        } catch (error) {
            setDoisFatores(null);
        }
    };

    useEffect(() => {
        carregarDoisFatores();
    }, []);

    useEffect(() => {
        const init = async () => {
            const response = await Usuarios.getUsuarios();
            const periodicidade = await PerfilApi().verificaPeriodicidade();
            const limiteLicenca = await PerfilApi().verificaLimiteLicenca();
            setLimiteLicencaAtingido(
                limiteLicenca === "LIMITE_USUARIOS" ? true : false,
            );
            setPeriodicidade(periodicidade);
            const presetsResp = await PerfilApi().getPresets();
            setPresets(presetsResp || []);
            setUsuariosNomes(() => {
                return response.map((item: any) => {
                    return {
                        value: item.nome,
                        name: item.nome,
                    };
                });
            });
            setMeusUsuarios(response);

            if (response.length === 1) {
                response[0].tipo = 1;
            }

            setUsuario(response[0]);

            usuario.novo = false;
            setLoading(false);
            setNeedInit(false);
        };

        if (loading || needInit) {
            init();
        }
    }, [usuario, needInit, loading, Usuarios]);

    // O painel de permissões aparece ao criar um usuário ou ao editar outro que não o gerente principal.
    const panelPermissoesVisivel =
        usuario.novo || (MeusUsuarios[0] && usuario.nome !== MeusUsuarios[0].nome);
    const permissoesPersonalizadas = panelPermissoesVisivel && isPersonalizado();

    // Assinatura fica dentro de Usuários. Customizado só vê com ASSINATURAS_VER (180); não-customizado
    // (sem pílulas de usuários) vê como hoje (regra 1). Mesmo truque das seções de Configurações.
    const temPillUsuarios = [
        PERMISSOES.USUARIOS_CRIAR,
        PERMISSOES.USUARIOS_EDITAR_GERAL,
        PERMISSOES.USUARIOS_EDITAR_MEU,
        PERMISSOES.USUARIOS_EXCLUIR,
    ].some((id) => permissoesUsuario?.includes(id));
    const mostrarAssinatura =
        !temPillUsuarios || permissoesUsuario?.includes(PERMISSOES.ASSINATURAS_VER);
    // Botões por ação; não-customizado (sem pílula) vê tudo como hoje (regra 1).
    const mostrarAdicionarUsuario = !temPillUsuarios || permissoesUsuario?.includes(PERMISSOES.USUARIOS_CRIAR);
    const mostrarExcluirUsuario = !temPillUsuarios || permissoesUsuario?.includes(PERMISSOES.USUARIOS_EXCLUIR);

    return (
        <ViewPerfil theme={theme}>
            <LeftRight theme={theme}>
                {loading ? (
                    <SkeletonPerfil/>
                ) : (
                    <Form className="edicao-usuario" id="edicao-usuario" setFormValid={setSalvarHabilitado}
                          onSubmit={() => handleSalvar(usuario)}>
                        <div className="titulo fonteTitulo">Usuário de acesso</div>
                        <div className="campos fonteRotulos">
                            {!usuario.novo ? (
                                <div
                                    className={
                                        usuario.novo ||
                                        usuario.nome == MeusUsuarios[0].nome
                                            ? "alterar novo"
                                            : "alterar"
                                    }
                                >
                                    <Select
                                        label="Usuário"
                                        options={usuariosNomes.map(item => {
                                            // Identificar o objeto de usuário correspondente
                                            const usuarioObj = MeusUsuarios.find(u => u.nome === item.value);

                                            // Verificar se tem um email válido
                                            const temEmailValido = usuarioObj?.email && validateEmail(usuarioObj.email);

                                            // Verificar se existem emails duplicados
                                            const emailRepetido = temEmailValido &&
                                                MeusUsuarios.filter(u =>
                                                    u.email === usuarioObj.email &&
                                                    validateEmail(u.email)
                                                ).length > 1;

                                            // Definir o texto de exibição
                                            let displayText: any = item.value; // Nome de usuário como fallback

                                            if (temEmailValido) {
                                                displayText = usuarioObj.email;
                                                // Se o email for repetido, adiciona o nome do usuário para distinguir
                                                if (emailRepetido) {
                                                    displayText += ` (${usuarioObj.nome})`;
                                                }
                                            }

                                            return {
                                                ...item,
                                                name: displayText
                                            };
                                        })}
                                        required={true}
                                        value={usuario.nome}
                                        onChange={async (newValue) => {
                                            const found = MeusUsuarios.find(
                                                (item: any) => item.nome === newValue,
                                            );
                                            setUsuario(found);
                                            // Carrega as permissões efetivas do usuário selecionado
                                            // (o próprio gerente não é editável por aqui).
                                            if (found && MeusUsuarios[0].nome !== found.nome) {
                                                try {
                                                    const eff = await PerfilApi().permissoesEfetivas(found.nome);
                                                    setUsuario((prev: any) =>
                                                        prev && prev.nome === found.nome
                                                            ? {...prev, permissoes: legadoParaFino(eff.permissoes)}
                                                            : prev,
                                                    );
                                                } catch (e) {
                                                    // silencioso: mantém sem pré-marcação se falhar
                                                }
                                            }
                                        }}
                                    />
                                    {!usuario.novo &&
                                    MeusUsuarios[0].nome != usuario.nome &&
                                    mostrarExcluirUsuario ? (
                                        <div
                                            className="botao_excluir"
                                            onClick={() => {
                                                removerUsuario();
                                            }}
                                        >
                                            Excluir
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}

                            {usuario.novo ? (
                                <div className={usuario.novo ? "alterar novo" : "alterar"}>
                                    <Input
                                        label="E-mail de acesso, para login"
                                        type="text"
                                        name="email"
                                        required={true}
                                        isValid={{
                                            isValidFunction: (value: string) => {
                                                return validateEmail(value) && !nomeJaExiste;
                                            },
                                            dependencies: [usuario.email, nomeJaExiste]
                                        }}
                                        invalidText={!validateEmail(usuario.email) ? "Email inválido" : "Email já está em uso como nome de usuário"}
                                        value={usuario.email}
                                        onDebounce={async (newValue) => {
                                            if (validateEmail(newValue)) {
                                                await verificaNomeUsuario(newValue);
                                            }
                                            setLoadingNomeUsuario(false);
                                        }}
                                        debounceTime={1000}
                                        onChange={(newValue) => {
                                            setUsuario({
                                                ...usuario,
                                                email: newValue,
                                                nome: newValue
                                            });
                                        }}
                                        placeholder="E-mail para login"
                                    />
                                </div>
                            ) : null}

                            <div className={usuario.novo ? "alterar novo" : "alterar"}>
                                <Input
                                    label="E-mail para romaneio de pedidos"
                                    type="text"
                                    name="email_notificacao"
                                    required={true}
                                    isValid={{
                                        isValidFunction: validateEmail,
                                        dependencies: [usuario.email_notificacao]
                                    }}
                                    invalidText={!validateEmail(usuario.email_notificacao) ? "Email inválido" : ""}
                                    value={usuario.email_notificacao}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            email_notificacao: newValue,
                                        });
                                    }}
                                    placeholder="E-mail para notificações"
                                    disabled={!usuario.novo ? true : false}
                                />
                                {!usuario.novo ? (
                                    <div
                                        className="botao_alterar fonteTexto"
                                        onClick={() => {
                                            setPhoneBox(false);
                                            setPassBox(false);
                                            setMailBox(true);
                                            setPlanBox(false);
                                            setDoisFatoresBox(false);
                                        }}
                                    >
                                        Alterar
                                    </div>
                                ) : null}
                            </div>

                            <div
                                className={
                                    usuario.novo ? "alterar novo" : "alterar"
                                }
                            >
                                <Input
                                    label="Telefone"
                                    type="text"
                                    name="Telefone"
                                    required={true}
                                    mask={{
                                        mask: phoneMask,
                                        unmask: unmaskToNumbers,
                                        maskValidation: validatePhone
                                    }}
                                    isValid={{
                                        isValidFunction: validatePhone,
                                        dependencies: [usuario.telefone],
                                    }}
                                    value={usuario.telefone}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            telefone: newValue,
                                        });
                                    }}
                                    placeholder="Telefone"
                                    disabled={!usuario.novo ? true : false}
                                />
                                {!usuario.novo ? (
                                    <div
                                        className="botao_alterar fonteTexto"
                                        onClick={() => {
                                            setMailBox(false);
                                            setPassBox(false);
                                            setPhoneBox(true);
                                            setPlanBox(false);
                                            setDoisFatoresBox(false);
                                        }}
                                    >
                                        Alterar
                                    </div>
                                ) : null}
                            </div>

                            <div
                                className={
                                    usuario.novo ? "alterar novo" : "alterar"
                                }
                            >
                                <Input
                                    label="Senha"
                                    type="password"
                                    name="senha"
                                    value={usuario.senha}
                                    required={true}
                                    minLength={6}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            senha: newValue,
                                        });
                                    }}
                                    placeholder={"******"}
                                    error=""
                                    disabled={!usuario.novo ? true : false}
                                />
                                {!usuario.novo ? (
                                    <div
                                        className="botao_alterar fonteTexto"
                                        onClick={() => {
                                            setMailBox(false);
                                            setPhoneBox(false);
                                            setPassBox(true);
                                            setPlanBox(false);
                                            setDoisFatoresBox(false);
                                        }}
                                    >
                                        Alterar
                                    </div>
                                ) : null}
                            </div>

                            {!usuario.novo && empresa?.usuario && usuario.nome === empresa.usuario ? (
                                <div className="alterar">
                                    <Input
                                        label="Autenticação de dois fatores"
                                        type="text"
                                        name="dois_fatores"
                                        value={doisFatores?.ativo ? "Ativada" : "Desativada"}
                                        onChange={() => {
                                        }}
                                        placeholder=""
                                        disabled={true}
                                    />
                                    <div
                                        className="botao_alterar fonteTexto"
                                        onClick={() => {
                                            setMailBox(false);
                                            setPhoneBox(false);
                                            setPassBox(false);
                                            setPlanBox(false);
                                            setDoisFatoresBox(true);
                                        }}
                                    >
                                        {doisFatores?.ativo ? "Desativar" : "Ativar"}
                                    </div>
                                </div>
                            ) : null}
                            <Select
                                label="Permissão"
                                name="permissão"
                                required={true}
                                infoModal={handleInfoModal}
                                value={permissoesPersonalizadas ? "personalizado" : usuario.tipo}
                                onChange={(newValue) => {
                                    // "Personalizado" é só um rótulo de estado divergente: não reseta nada.
                                    if (newValue === "personalizado") return;
                                    // Aplica o preset (cargo) escolhido: pré-marca as permissões dele.
                                    setUsuario({
                                        ...usuario,
                                        tipo: newValue,
                                        permissoes: getPresetPermissoes(newValue),
                                    });
                                }}
                                placeholder="Permissão"
                                options={[
                                    ...((usuariosNomes.length > 1 || usuario.novo) &&
                                    MeusUsuarios[0].tipo == "1" &&
                                    MeusUsuarios[0].nome != usuario.nome
                                        ? [
                                            { name: "Gerente", value: "1" },
                                            { name: "Vendedor Interno", value: "2" },
                                            { name: "Vendedor Externo", value: "4" },
                                        ]
                                        : [{ name: "Gerente", value: "1" }]),
                                    ...(permissoesPersonalizadas
                                        ? [{ name: "Personalizado", value: "personalizado" }]
                                        : []),
                                ]}
                            />
                            {panelPermissoesVisivel && (
                                <PainelPermissoes
                                    permissoes={Array.isArray(usuario.permissoes) ? usuario.permissoes : []}
                                    onChange={(next) =>
                                        setUsuario((prev: any) => ({ ...prev, permissoes: next }))
                                    }
                                    contexto={{ relatoriosPersonalizados: true }}
                                />
                            )}
                            <div className="botoes_ fonteTexto">
                                {mostrarAdicionarUsuario && (
                                <div
                                    className={!limiteLicencaAtingido ? "novo_usuario" : "novo_usuario bloqueado"}
                                    onClick={() => {
                                        if (!limiteLicencaAtingido) {
                                            if (usuario.novo) {
                                                setUsuario(MeusUsuarios[0]);
                                            } else {
                                                handleNovoUsuario();
                                            }
                                        } else {
                                            setAvisoLimiteAtingido(true);
                                        }
                                    }}
                                >
                                    {!usuario.novo
                                        ? "Adicionar novo usuário"
                                        : "Editar usuários"}
                                    {!limiteLicencaAtingido ? null : <LockedIcon
                                        mensagem="Limite de usuários atingidos para o plano, faça o upgrade."
                                        width="20px"/>}
                                </div>
                                )}
                                <Button
                                    title="Salvar alterações"
                                    className={`fonteTexto botao_alterar ${salvarHabilitado ? "" : "disabled"}`}
                                    width="50%"
                                    padding="0"
                                    type="submit"
                                    loading={loadingNomeUsuario}
                                />
                            </div>
                        </div>
                        {fluxoNovo === false && mostrarAssinatura && (
                            <>
                                <div className="linha_abaixo"></div>
                                <div className="titulo_assinatura fonteTitulo">Assinatura</div>

                                <div className={[8, 26].includes(empresa?.id_plano as number) ? "alterar_sem_botao" : "alterar"}>
                                    <Input
                                        label="Plano contratado"
                                        type="text"
                                        name="nome"
                                        className="fonteTexto"
                                        value={(periodicidade.nome_plano && ![8, 26].includes(empresa?.id_plano as number)) ? `${periodicidade.nome_plano} (${periodicidade.periodicidade})` : periodicidade.periodicidade}
                                        onChange={(newValue) => {
                                            setPeriodicidade({
                                                ...periodicidade,
                                                periodicidade: newValue,
                                            });
                                        }}
                                        placeholder={"Plano"}
                                        error=""
                                        disabled={true}
                                    />
                                    {![8, 26].includes(empresa?.id_plano as number) && (
                                        <Link
                                            className="botao_alterar"
                                            to="/perfil/usuarios/planos"
                                        >
                                            Alterar
                                        </Link>
                                    )}
                                </div>

                                <div style={{ display: "flex", gap: "1.5rem", marginTop: "1rem", justifyContent: "space-between" }}>
                                    <div
                                        className="botao_alterar fonteTexto detalhes"
                                        onClick={handleVerDetalhesAssinatura}
                                        style={{ cursor: "pointer", color: theme.colors.primary }}
                                    >
                                        Ver detalhes da assinatura
                                    </div>
                                    <a
                                        className="botao_alterar fonteTexto detalhes"
                                        href="/perfil/atualizar-dados"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ cursor: "pointer", color: theme.colors.primary, textDecoration: "none" }}
                                    >
                                        Trocar dados do cartão
                                    </a>
                                </div>
                            </>
                        )}
                    </Form>
                )}
            </LeftRight>
            <Middle theme={theme}>
                <div></div>
            </Middle>
            <LeftRight theme={theme}>
                {window.innerWidth > 1024 ? (
                    <>
                        <SlidingBox
                            active={mailBox}
                            direction="right"
                        >
                            <MailBox
                                setMailBox={setMailBox}
                                onChange={(newValue) => {
                                    const newMail = {...usuario, email_notificacao: newValue};
                                    setUsuario(newMail);
                                    handleSalvar(newMail)
                                }}
                            />
                        </SlidingBox>
                        <SlidingBox
                            active={phoneBox}
                            direction="right"
                        >
                            <PhoneBox
                                setPhoneBox={setPhoneBox}
                                actualPhone={usuario.telefone}
                                onChange={(newValue) => {
                                    const newPhone = {...usuario, telefone: newValue};
                                    setUsuario(newPhone);
                                    handleSalvar(newPhone);
                                }}
                            />
                        </SlidingBox>
                        <SlidingBox
                            active={passBox}
                            direction="right"
                        >
                            <PassBox
                                setPassBox={setPassBox}
                                onChange={(newValue) => {
                                    const newUsuario = {...usuario, senha: newValue};
                                    setUsuario(newUsuario);
                                    handleSalvar(newUsuario);
                                }}
                            />
                        </SlidingBox>
                        <SlidingBox
                            active={doisFatoresBox}
                            direction="right"
                        >
                            <DoisFatoresBox
                                key={`2fa-${doisFatoresBox}-${doisFatores?.ativo}`}
                                setDoisFatoresBox={setDoisFatoresBox}
                                status={doisFatores}
                                onChange={carregarDoisFatores}
                            />
                        </SlidingBox>
                        <SlidingBox
                            active={planBox}
                            direction="right"
                        >
                            <PlanBox
                                planoAtual={periodicidade.periodicidade}
                                setPlanBox={setPlanBox}
                            />
                        </SlidingBox>
                    </>
                ) : (
                    <>
                        <Modal
                            hideDesktop
                            isOpen={mailBox}
                            setModal={setMailBox}
                            children={
                                <MailBox
                                    setMailBox={setMailBox}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            email_notificacao: newValue,
                                        });
                                    }}
                                />
                            }
                            width="90%"
                            align="center"
                            justify="center"
                            padding="30px"
                            animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                            margin="0rem 2rem 0rem 2rem"
                        />
                        <Modal
                            hideDesktop
                            isOpen={phoneBox}
                            setModal={setPhoneBox}
                            children={
                                <PhoneBox
                                    setPhoneBox={setPhoneBox}
                                    actualPhone={usuario.telefone}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            telefone: newValue,
                                        });
                                    }}
                                />
                            }
                            width="90%"
                            align="center"
                            justify="center"
                            padding="30px"
                            animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                            margin="0rem 2rem 0rem 2rem"
                        />
                        <Modal
                            hideDesktop
                            isOpen={passBox}
                            setModal={setPassBox}
                            children={
                                <PassBox
                                    setPassBox={setPassBox}
                                    onChange={(newValue) => {
                                        setUsuario({
                                            ...usuario,
                                            senha: newValue,
                                        });
                                    }}
                                />
                            }
                            width="90%"
                            align="center"
                            justify="center"
                            padding="30px"
                            animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                            margin="0rem 2rem 0rem 2rem"
                        />
                        <Modal
                            hideDesktop
                            isOpen={doisFatoresBox}
                            setModal={setDoisFatoresBox}
                            children={
                                <DoisFatoresBox
                                    key={`2fa-${doisFatoresBox}-${doisFatores?.ativo}`}
                                    setDoisFatoresBox={setDoisFatoresBox}
                                    status={doisFatores}
                                    onChange={carregarDoisFatores}
                                />
                            }
                            width="90%"
                            align="center"
                            justify="center"
                            padding="30px"
                            animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                            margin="0rem 2rem 0rem 2rem"
                        />
                        <Modal
                            hideDesktop
                            isOpen={planBox}
                            setModal={setPlanBox}
                            children={
                                <PlanBox
                                    planoAtual={periodicidade.periodicidade}
                                    setPlanBox={setPlanBox}
                                />
                            }
                            width="90%"
                            align="center"
                            justify="center"
                            animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                            padding="3rem"
                            margin="0rem 2rem 0rem 2rem"
                        />
                    </>
                )}
            </LeftRight>
            <Modal
                isOpen={avisoLimiteAtingido}
                setModal={setAvisoLimiteAtingido}
                children={
                    <div className="aviso_limite_atingido">
                        <Titulo
                            justifyContent="center"
                            flexDirection="column-reverse"
                            titulo="Limite de usuários atingido"
                            subtitulo={`  Você atingiu o limite de usuários permitidos para o seu plano. Para adicionar mais usuários, entre em contato com o nosso suporte.`}
                        />
                        <div
                            className="botoes"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-around",
                            }}
                        >
                            <div
                                className="cancelar"
                                style={{
                                    color: theme.colors.primary,
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setAvisoLimiteAtingido(false);
                                }}
                            >
                                Cancelar
                            </div>
                            <Button
                                title="Falar com atendimento"
                                className="botao_ok"
                                width="50%"
                                padding="0"
                                onClick={() => {
                                    const url = `https://api.whatsapp.com/send?phone=555434434563&text=
                            Olá, gostaria de adicionar mais usuários na minha conta.`;
                                    window.open(url, "_blank");
                                }}
                            />
                        </div>
                    </div>
                }
                width="100rem"
                maxWidth="99%"
                align="center"
                justify="center"
                animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                padding="30px"
                margin="0rem 2rem 0rem 2rem"
            />
            <Modal
                isOpen={modalAtualizando}
                setModal={() => modalAtualizando}
                children={
                    <ModalSucesso message={mensagemModal} type={stateModal}/>
                }
                width="35vw"
                align="center"
                justify="center"
                animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                margin="0rem 2rem 0rem 2rem"
            />
            <Modal
                isOpen={modalPermissao}
                setModal={setmodalPermissao}
                children={
                    <>
                        <Titulo
                            justifyContent="center"
                            flexDirection="column-reverse"
                            titulo="Permissões de usuários"
                            subtitulo={``}
                        />
                        <ViewModalPermissoes>
                            <div className="titulo fonteSubtitulo">Gerente</div>
                            <div className="texto fonteTexto">
                                Possui permissão para criação de catálogos,
                                cadastro/edição de produtos, gerenciamento de
                                novos usuários (vendedores) e visualização de
                                todos os pedidos de todos os vendedores.
                            </div>
                            <div className="titulo fonteSubtitulo">Vendedor Interno</div>
                            <div className="texto fonteTexto">
                                Possui permissão para criação de catálogos,
                                visualização de seus pedidos e cadastro/edição
                                de produtos.
                            </div>
                            <div className="titulo fonteSubtitulo">Vendedor Externo</div>
                            <div className="texto fonteTexto">
                                Possui permissão para criação de catálogos e
                                visualização de seus pedidos.
                            </div>
                        </ViewModalPermissoes>
                        <div
                            className="botoes"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                            }}
                        >
                            <Button
                                title="Fechar"
                                className="botao_ok fonteTexto"
                                width="50%"
                                padding="0"
                                onClick={() => {
                                    setmodalPermissao(false);
                                }}
                            />
                        </div>
                    </>
                }
                width={window.innerWidth > 762 ? "50%" : "95%"}
                align="center"
                justify="center"
                animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                padding="30px"
                margin="0rem 2rem 0rem 2rem"
            />
            {fluxoNovo === false && (
                <Modal
                    isOpen={modalDetalhesAssinatura}
                    setModal={setModalDetalhesAssinatura}
                    width={'100rem'}
                    align="center"
                    justify="center"
                    animation="opacity 400ms cubic-bezier(0.4, 0, 0.2, 1)"
                    margin="0rem 2rem 0rem 2rem"
                    padding={"3rem"}
                >
                    <Titulo
                        justifyContent="center"
                        flexDirection="column-reverse"
                        titulo="Detalhes da Assinatura"
                        subtitulo=""
                    />
                    <ViewModalDetalhesAssinatura theme={theme}>
                        {loadingDetalhes ? (
                            <div className={"loading-detalhes"}>
                                <Player
                                    autoplay
                                    loop
                                    src={src}
                                    style={{
                                        height: "12rem",
                                        width: "12rem",
                                        position: "static",
                                        right: "0",
                                        top: "0",
                                        bottom: "0",
                                        margin: "auto",
                                    }}
                                >
                                    <Controls
                                        visible={false}
                                        buttons={["play", "repeat", "frame", "debug"]}
                                    />
                                </Player>
                            </div>
                        ) : detalhesAssinatura ? (
                            <>
                                {detalhesAssinatura.inicio_trial && detalhesAssinatura.fim_trial && (
                                    <div className="trial-info">
                                        <div className="info-row">
                                            <span className="info-label">Período de teste grátis</span>
                                            <span className="info-value">
                                                {moment(detalhesAssinatura.inicio_trial, "MM/DD/YYYY").format("DD/MM/YYYY")} até {moment(detalhesAssinatura.fim_trial, "MM/DD/YYYY").format("DD/MM/YYYY")}
                                            </span>
                                        </div>
                                    </div>
                                )}

                                <div className="info-row">
                                    <span className="info-label">Plano</span>
                                    <span className="info-value">{detalhesAssinatura.plano?.nome}</span>
                                </div>
                                <div className="info-row">
                                    <span className="info-label">Periodicidade</span>
                                    <span className="info-value">{periodicidade.periodicidade}</span>
                                </div>

                                {detalhesAssinatura.plano?.valor > detalhesAssinatura.plano?.valor_cheio ? (
                                    <div className="info-row">
                                        <span className="info-label">Valor</span>
                                        <span className="info-value">
                                            R$ {detalhesAssinatura.plano?.valor?.toLocaleString("pt-BR", {minimumFractionDigits: 2})}
                                        </span>
                                    </div>
                                ) : (
                                    <>
                                        <div className="info-row">
                                            <span className="info-label">Valor original</span>
                                            <span className="info-value">
                                                R$ {detalhesAssinatura.plano?.valor_cheio?.toLocaleString("pt-BR", {minimumFractionDigits: 2})}
                                            </span>
                                        </div>

                                        {detalhesAssinatura.plano?.valor < detalhesAssinatura.plano?.valor_cheio && (
                                            <div className="info-row">
                                                <span className="info-label">Desconto do plano</span>
                                                <span className="info-value desconto">
                                                    - R$ {(detalhesAssinatura.plano.valor_cheio - detalhesAssinatura.plano.valor).toLocaleString("pt-BR", {minimumFractionDigits: 2})}
                                                </span>
                                            </div>
                                        )}

                                        {detalhesAssinatura.cupom && (
                                            <div className="info-row">
                                                <span className="info-label">
                                                    Cupom <span className="cupom-badge">{detalhesAssinatura.cupom.nome}</span>
                                                </span>
                                                <span className="info-value desconto">
                                                    - {detalhesAssinatura.cupom.tipo_desconto === "percentual"
                                                        ? `${detalhesAssinatura.cupom.desconto}% (R$ ${(detalhesAssinatura.plano.valor * detalhesAssinatura.cupom.desconto / 100).toLocaleString("pt-BR", {minimumFractionDigits: 2})})`
                                                        : `R$ ${detalhesAssinatura.cupom.desconto.toLocaleString("pt-BR", {minimumFractionDigits: 2})}`}
                                                </span>
                                            </div>
                                        )}

                                        <div className="info-row valor-final">
                                            <span className="info-label">Valor final</span>
                                            <span className="info-value">
                                                R$ {(() => {
                                                    const valor = detalhesAssinatura.plano?.valor || 0;
                                                    const cupom = detalhesAssinatura.cupom;
                                                    if (!cupom) return valor.toLocaleString("pt-BR", {minimumFractionDigits: 2});

                                                    const descontoCupom = cupom.tipo_desconto === "percentual"
                                                        ? valor * (cupom.desconto / 100)
                                                        : cupom.desconto;

                                                    return (valor - descontoCupom).toLocaleString("pt-BR", {minimumFractionDigits: 2});
                                                })()}
                                            </span>
                                        </div>
                                    </>
                                )}

                                {detalhesAssinatura.plano?.parcelas && (
                                    <div className="info-row">
                                        <span className="info-label">Parcelas</span>
                                        <span className="info-value">{detalhesAssinatura.plano.parcelas}x</span>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div style={{textAlign: "center", padding: "2rem"}}>
                                Não foi possível carregar os detalhes.
                            </div>
                        )}
                    </ViewModalDetalhesAssinatura>
                    <div style={{display: "flex", justifyContent: "center", marginTop: "1.5rem"}}>
                        <Button
                            title="Fechar"
                            className="botao_ok fonteTexto"
                            width="50%"
                            padding="0"
                            onClick={() => setModalDetalhesAssinatura(false)}
                        />
                    </div>
                </Modal>
            )}
        </ViewPerfil>
    );
};
